import { Stack, StackProps } from '@chakra-ui/react';
import React from 'react';

export const CmStack: React.FC<StackProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <Stack {...rest}>{children}</Stack>;
};
